module.exports = __webpack_public_path__ + "static/media/Coaching Review.b3f1975f.png";